var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightBoldArrow = function SvgRightBoldArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 16,
    height: 16,
    fill: "current",
    viewBox: "0 0 20.633 20.633"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.621 9.844 5.971.195A.65.65 0 0 0 5.5 0a.66.66 0 0 0-.473.195l-.013.012a.68.68 0 0 0-.197.475v4.682c0 .178.071.348.197.471l4.481 4.482-4.481 4.479a.67.67 0 0 0-.197.475v4.68c0 .18.071.354.197.475l.013.01a.664.664 0 0 0 .947 0l9.647-9.646a.67.67 0 0 0 0-.946"
  })));
};
export default SvgRightBoldArrow;